import { useTranslation } from 'react-i18next';
import Link from 'antd/es/typography/Link';
import { Collapse, CollapseProps } from 'antd/lib';
import classNames from 'classnames';
import { Icons } from '@monorepo/icons';
import { Flex, TextComponent } from '@monorepo/react-components';
import { useResponsiveness } from '@monorepo/react-hooks';
import { IconsNames } from '@monorepo/types';

import styles from './frequently-asked-questions.module.scss';

const FrequentlyAskedQuestions = () => {
  const { t } = useTranslation('affiliate');

  const { isMobile } = useResponsiveness();

  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: t('welcome.faq.questions.what_is_affiliate_program.q'),
      children: t('welcome.faq.questions.what_is_affiliate_program.a'),
    },
    {
      key: '2',
      label: t('welcome.faq.questions.who_can_sign_up.q'),
      children: t('welcome.faq.questions.who_can_sign_up.a'),
    },
    {
      key: '3',
      label: t('welcome.faq.questions.how_to_get_link.q'),
      children: t('welcome.faq.questions.how_to_get_link.a'),
    },
    {
      key: '4',
      label: t('welcome.faq.questions.how_do_i_earn.q'),
      children: t('welcome.faq.questions.how_do_i_earn.a'),
    },
    {
      key: '5',
      label: t('welcome.faq.questions.where_can_i_share.q'),
      children: t('welcome.faq.questions.where_can_i_share.a'),
    },
    {
      key: '6',
      label: t('welcome.faq.questions.how_can_i_get_paid.q'),
      children: t('welcome.faq.questions.how_can_i_get_paid.a'),
    },
    {
      key: '7',
      label: t('welcome.faq.questions.can_i_use_ads.q'),
      children: t('welcome.faq.questions.can_i_use_ads.a'),
    },
    {
      key: '8',
      label: t('welcome.faq.questions.who_to_contact.q'),
      children: t('welcome.faq.questions.who_to_contact.a'),
    },
  ];

  return (
    <Flex
      vertical={isMobile}
      className={classNames(styles.faqWrapper, { [styles.mobile]: isMobile })}
    >
      <Flex
        vertical
        gap={10}
        className={styles.titleWrapper}
        align={isMobile ? 'center' : 'flex-start'}
      >
        <Flex className={styles.title}>
          <TextComponent
            level={2}
            weight={600}
            textAlign={isMobile ? 'center' : 'left'}
          >
            {t('welcome.faq.frequently_asked_questions')}
          </TextComponent>
        </Flex>
        <Flex className={styles.needHelp}>
          <Icons iconName={IconsNames.Chat} />
          <TextComponent level={7} weight={400}>
            {t('welcome.faq.still_need_help')}
          </TextComponent>
          <Link underline>{t('welcome.faq.chat_with_us')}</Link>
        </Flex>
      </Flex>
      <Flex className={styles.content}>
        <Collapse items={items} />
      </Flex>
    </Flex>
  );
};

export default FrequentlyAskedQuestions;
